module.exports = __webpack_public_path__ + "img/BANDEAU_FILTRE_ACTIVE.2ef53131.svg";